export const css = {
    root: '_2d83n-_U',
    button: '_2IoXGZ7U',
    text: '_2qt1I-sP',
    ' _key': 'dashboard-widgets/praise'
};
export default css;
